/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: AI Assistant
 🏢 Company: Ring2All LLC
 📄 File: ModulePageContainer.tsx
 🗓️ Created: 2025-01-18
 🧩 Description:
    Reusable container component for module pages.
    Provides consistent layout and view switching between list and form.

 🔧 Usage:
    <ModulePageContainer
      currentView={currentView}
      listView={<YourListComponent />}
      formView={<YourFormComponent />}
    />

 🔁 Last Updated: 2025-01-18 by AI Assistant
────────────────────────────────────────────────────────────────*/

import { ReactNode } from 'react';

interface ModulePageContainerProps {
  currentView: 'list' | 'form';
  listView: ReactNode;
  formView: ReactNode;
  children?: ReactNode;
}

export function ModulePageContainer({
  currentView,
  listView,
  formView,
  children
}: ModulePageContainerProps) {
  // NotificationContainerSimple is now handled globally by NotificationProvider
  // No need to render it here to avoid duplicates

  return (
    <div className="max-w-[1920px] mx-auto">
      {currentView === 'list' ? (
        <div className="p-6">
          {listView}
        </div>
      ) : (
        <div className="p-6 pt-4">
          {formView}
        </div>
      )}
      
      {/* Additional content like modals */}
      {children}
    </div>
  );
}

export default ModulePageContainer;

